module.exports = __webpack_public_path__ + "img/Lady_Carrying_Document.369792f.png";